import { useQuery } from '@tanstack/react-query';
import { attemptGetLocationTypes } from '../../api/LocationApi';

export const useFetchLocationType = () => {
    return useQuery({
        queryKey: ['location-types'],
        queryFn: () => attemptGetLocationTypes(),
    });
};
